"use strict";
require('./CompanyPublicationPlantService.js');
var LIMIT = 20;

CompanyPublicationPlantReportCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  '$filter',
  'config',
  'CompanyPublicationPlantService',
  'deliveries'];
function CompanyPublicationPlantReportCtrl(
  $scope,
  $stateParams,
  $state,
  $filter,
  config,
  plantService,
  deliveries) {
  $scope.deliveries = deliveries;
  $scope.currentPage   = $stateParams.page|0;

  $scope.plantDataQuery = $stateParams.t || "";
  var startDate = Date.parse($stateParams.from);
  var endDate   = Date.parse($stateParams.to);

  $scope.plantDataSpan  = {
    from: startDate ? new Date(startDate) : null,
    to:   endDate   ? new Date(endDate)   : null
  };

  $scope.search = function(event) {
    event.preventDefault();

    var query = {
      page: 0,
      t: $scope.plantDataQuery
    };

    if ($scope.plantDataSpan.from) {
      query.from = $filter('date')($scope.plantDataSpan.from, "yyyy-MM-dd");
    }

    if ($scope.plantDataSpan.to) {
      query.to = $filter('date')($scope.plantDataSpan.to, "yyyy-MM-dd");
    }

    $state.go("root.company.publication.plant-report", query, { location: "replace" });
  };

  $scope.downloadExcel = function() {
    var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + $stateParams.publicationId + '/export-deliveries?all=true&type=plant&id=' + $stateParams.plantId + '&lang=' + window.localStorage.language;
    if ($scope.plantDataSpan.from) {
      url = url.concat('&from=', $filter('date')($scope.plantDataSpan.from, "yyyy-MM-dd"));
    }

    if ($scope.plantDataSpan.to) {
      url = url.concat('&to=', $filter('date')($scope.plantDataSpan.to, "yyyy-MM-dd"));
    }

    if ($scope.plantDataQuery) {
      url = url.concat('&t=', $scope.plantDataQuery);
    }

    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    if (true === iOS) {
      window.open(url, '_self');
      return;
    }

    var elm = angular.element(document.querySelector('body'));
    var iFrame = elm.find('#downloadWindow');
    if (!(iFrame && iFrame.length > 0)) {
      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
      elm.append(iFrame);
    }

    iFrame.attr('src',url);
  };
}

CompanyPublicationPlantReportCtrl.resolve = {
  deliveries: [
    'CompanyPublicationPlantService',
    '$stateParams',
    function(plantService, $stateParams){
    var filter = {
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      plantId: $stateParams.plantId,
      offset: ($stateParams.page|0) * LIMIT,
      limit:  LIMIT + 1
    };

    if ($stateParams.from) {
      filter.from = $stateParams.from;
    }

    if ($stateParams.to) {
      filter.to = $stateParams.to;
    }

    if($stateParams.t) {
      filter.t = $stateParams.t;
    }

    return plantService.queryDeliveries(filter).$promise;
  }]
};

module.exports = CompanyPublicationPlantReportCtrl;

angular.module("dokiv")
  .controller("CompanyPublicationPlantReportCtrl", CompanyPublicationPlantReportCtrl);






//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/plant/CompanyPublicationPlantReportCtrl.js
// module id = 405
// module chunks = 0